import { useQuery } from '@tanstack/react-query';
import { billingSplitQueryKey } from 'Data/keys/QueryKeys';
import { RateioApi } from 'Data/Rateio.api';
import { useRateioScope } from './RateioScope';

// Estado de faturamento do tenant: modo (empresa única / rateio), SPEs e pesos.
// O tenant vem do RateioScope: o do usuário, ou o selecionado no painel /adm.
export const useQueryBillingSplit = () => {
  const { tenantId } = useRateioScope();

  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: billingSplitQueryKey(tenantId),
    // No /adm o rateio pode ter sido alterado pelo cliente há pouco: sem cache.
    staleTime: tenantId ? 0 : 60 * 5 * 1000, // 5 minutes
    queryFn: async () => {
      return RateioApi.getBillingSplit(tenantId);
    },
  });

  return {
    billingSplit: data,
    refetch,
    isLoading,
    isFetching,
    error,
  };
};
